import { permissionManager } from '../PermissionManager/PermissionManager';

export const ORGANIZE_TAB_EXTRACT = 'extract-pages-button';
export const ORGANIZE_TAB_MOVE = 'move-pages-button';
export const ORGANIZE_TAB_SPLIT = 'split-document-button';
export const ORGANIZE_TAB_FLATTEN = 'file-tab-flatten';

export const ORGANIZE_TAB_WATERMARK = 'file-tab-watermark';
export const ORGANIZE_TAB_WATERMARK_ADD = 'file-tab-watermark-add';
export const ORGANIZE_TAB_WATERMARK_UPDATE = 'file-tab-watermark-update';
export const ORGANIZE_TAB_WATERMARK_REMOVEALL = 'file-tab-watermark-removeAll';

export const ORGANIZE_TAB_BACKGROUND = 'file-tab-background';
export const ORGANIZE_TAB_BACKGROUND_ADD = 'file-tab-background-add';
export const ORGANIZE_TAB_BACKGROUND_UPDATE = 'file-tab-background-update';
export const ORGANIZE_TAB_BACKGROUND_REMOVEALL = 'file-tab-background-removeAll';

export const ORGANIZE_TAB_HEADER_FOOTER = 'file-tab-header-footer';
export const ORGANIZE_TAB_HEADER_FOOTER_ADD = 'file-tab-header-footer-add';
export const ORGANIZE_TAB_HEADER_FOOTER_UPDATE = 'file-tab-header-footer-update';
export const ORGANIZE_TAB_HEADER_FOOTER_REMOVEALL = 'file-tab-header-footer-removeAll';

export const ORGANIZE_TAB_BATES_NUMBERING = 'file-tab-bates-numbering';
export const ORGANIZE_TAB_BATES_NUMBERING_ADD = 'file-tab-bates-numbering-add';
export const ORGANIZE_TAB_BATES_NUMBERING_REMOVEALL = 'file-tab-bates-numbering-removeAll';

export const ORGANIZE_TAB_PAGE_INSERT_FROM_FILE = 'organize-tab-page-insert-from-file';
export const ORGANIZE_TAB_PAGE_INSERT_FROM_CLIPBOARD = 'organize-tab-page-insert-from-clipboard';
export const ORGANIZE_TAB_PAGE_INSERT_BLANK_PAGE = 'organize-tab-page-insert-blank-page';
export const ORGANIZE_TAB_PAGE_INSERT_INTO_FILE = 'organize-tab-page-insert-into-file';
export const ORGANIZE_TAB_PAGE_DELETE = 'delete-pages-button';
export const ORGANIZE_TAB_PAGE_REVERSE = 'organize-tab-page-reverse';
export const ORGANIZE_TAB_PAGE_ROTATE = 'file-tab-page-rotate';
export const ORGANIZE_TAB_PAGE_DUPLICATE = 'duplicate-pages-button';
export const ORGANIZE_TAB_PAGE_CROP = 'crop-pages-button';
export const ORGANIZE_TAB_PAGE_ROTATE_LEFT = 'file-tab-page-rotate-left';
export const ORGANIZE_TAB_PAGE_ROTATE_RIGHT = 'file-tab-page-rotate-right';
export const ORGANIZE_TAB_PAGE_ROTATE_MULTIPLE = 'file-tab-page-rotate-multiple';
export const ORGANIZE_TAB_PAGE_INSERT_BLANK = 'insert-blank-page-cpnt';
export const ORGANIZE_TAB_PAGE_INSERT_FILE = 'insert-pages-from-cpnt';
export const ORGANIZE_TAB_REPLACE = 'replace-pages-button';
export const ORGANIZE_TAB_SWAP = 'swap-pages-button';
export const ORGANIZE_TAB_FORMAT_PAGE_NUMBERS = 'format-page-numbers-button';

export const HOME_TAB_WATERMARK_REMOVEALL = 'home-tab-watermark-removeAll';
export const HOME_TAB_BACKGROUND_REMOVEALL = 'home-tab-background-removeAll';
export const HOME_TAB_HEADERFOOTER_REMOVEALL = 'home-tab-headerfooter-removeAll';
export const HOME_TAB_BATESNUMBERING_REMOVEALL = 'home-tab-batesNumbering-removeAll';

export const HOME_TAB_PAGE_ROTATE = "home-tab-page-rotate";
export const HOME_TAB_PAGE_ROTATE_LEFT = "home-tab-page-rotate-left";
export const HOME_TAB_PAGE_ROTATE_RIGHT = "home-tab-page-rotate-right";
export const HOME_TAB_PAGE_ROTATE_MULTIPLE = "home-tab-page-rotate-multiple";

export const INSERT_PAGE_BY_DRAGGING = 'Insert page by dragging';

export const ORGANIZE_TAB_LIST = [ORGANIZE_TAB_EXTRACT, ORGANIZE_TAB_SPLIT, ORGANIZE_TAB_FLATTEN, ORGANIZE_TAB_WATERMARK, ORGANIZE_TAB_BACKGROUND, ORGANIZE_TAB_HEADER_FOOTER];

// premium features
export const ORGANIZE_PREMIUM_BTNS = [
  ORGANIZE_TAB_EXTRACT,
  ORGANIZE_TAB_SPLIT,
  ORGANIZE_TAB_FLATTEN,

  ORGANIZE_TAB_WATERMARK,
  ORGANIZE_TAB_WATERMARK_ADD,
  ORGANIZE_TAB_WATERMARK_UPDATE,
  ORGANIZE_TAB_WATERMARK_REMOVEALL,
  HOME_TAB_WATERMARK_REMOVEALL,
  HOME_TAB_BACKGROUND_REMOVEALL,
  ORGANIZE_TAB_BACKGROUND,
  ORGANIZE_TAB_BACKGROUND_ADD,
  ORGANIZE_TAB_BACKGROUND_UPDATE,
  ORGANIZE_TAB_BACKGROUND_REMOVEALL,

  ORGANIZE_TAB_HEADER_FOOTER,
  ORGANIZE_TAB_HEADER_FOOTER_ADD,
  ORGANIZE_TAB_HEADER_FOOTER_UPDATE,
  ORGANIZE_TAB_HEADER_FOOTER_REMOVEALL,

  ORGANIZE_TAB_BATES_NUMBERING,
  ORGANIZE_TAB_BATES_NUMBERING_ADD,
  ORGANIZE_TAB_BATES_NUMBERING_REMOVEALL,

  ORGANIZE_TAB_PAGE_INSERT_FROM_FILE,
  ORGANIZE_TAB_PAGE_INSERT_FROM_CLIPBOARD,
  ORGANIZE_TAB_PAGE_INSERT_BLANK_PAGE,
  ORGANIZE_TAB_PAGE_INSERT_INTO_FILE,
  ORGANIZE_TAB_PAGE_REVERSE,
  ORGANIZE_TAB_PAGE_ROTATE,
  ORGANIZE_TAB_PAGE_DELETE,
  ORGANIZE_TAB_PAGE_ROTATE_LEFT,
  ORGANIZE_TAB_PAGE_ROTATE_RIGHT,
  ORGANIZE_TAB_PAGE_ROTATE_MULTIPLE,
  HOME_TAB_PAGE_ROTATE,
  HOME_TAB_PAGE_ROTATE_LEFT,
  HOME_TAB_PAGE_ROTATE_RIGHT,
  HOME_TAB_PAGE_ROTATE_MULTIPLE,
  ORGANIZE_TAB_PAGE_DUPLICATE,
  ORGANIZE_TAB_PAGE_CROP,
  ORGANIZE_TAB_MOVE,
  ORGANIZE_TAB_PAGE_INSERT_BLANK,
  ORGANIZE_TAB_PAGE_INSERT_FILE,
  ORGANIZE_TAB_REPLACE,
  ORGANIZE_TAB_SWAP,
  ORGANIZE_TAB_FORMAT_PAGE_NUMBERS,
  INSERT_PAGE_BY_DRAGGING
];
permissionManager.registerPremiumFeatures(ORGANIZE_PREMIUM_BTNS);
permissionManager.registerCNJPPremiumFeatures(ORGANIZE_PREMIUM_BTNS);

export const CN_PAGE_PREMIUM_BTNS = [
  ORGANIZE_TAB_PAGE_DUPLICATE,
];

export const ORGANIZE_MAP = {
  extract: {
    name: ORGANIZE_TAB_EXTRACT,
    title: 'phantom_online:toolbar.organize.extract.title',
    tooltip: 'phantom_online:toolbar.organize.extract.tooltip',
    icon: 'fv__icon-toolbar-extract-pdf',
  },
  flatten: {
    name: ORGANIZE_TAB_FLATTEN,
    title: 'phantom_online:toolbar.organize.flatten.title',
    icon: 'fv__icon-toolbar-flatten-pdf',
  },
  watermark: {
    name: ORGANIZE_TAB_WATERMARK,
    title: 'phantom_online:toolbar.organize.watermark.title',
    icon: 'fv__icon-toolbar-watermark',
  },
  watermarkAdd: {
    name: ORGANIZE_TAB_WATERMARK_ADD,
    title: 'phantom_online:toolbar.organize.watermarkAdd.title',
    tooltip: 'phantom_online:toolbar.organize.watermarkAdd.tooltip',
    icon: 'fv__icon-toolbar-watermark-add',
  },
  watermarkUpdate: {
    name: ORGANIZE_TAB_WATERMARK_UPDATE,
    title: 'phantom_online:toolbar.organize.watermarkUpdate.title',
    tooltip: 'phantom_online:toolbar.organize.watermarkUpdate.tooltip',
    icon: 'fv__icon-toolbar-watermark-update',
  },
  watermarkRemoveAll: {
    name: ORGANIZE_TAB_WATERMARK_REMOVEALL,
    title: 'phantom_online:toolbar.organize.watermarkRemoveAll.title',
    tooltip: 'phantom_online:toolbar.organize.watermarkRemoveAll.tooltip',
    icon: 'fv__icon-toolbar-watermark-remove',
  },
  background: {
    name: ORGANIZE_TAB_BACKGROUND,
    title: 'phantom_online:toolbar.organize.background.title',
    icon: 'fv__icon-toolbar-background',
  },
  backgroundAdd: {
    name: ORGANIZE_TAB_BACKGROUND_ADD,
    title: 'phantom_online:toolbar.organize.backgroundAdd.title',
    tooltip: 'phantom_online:toolbar.organize.backgroundAdd.tooltip',
    icon: 'fv__icon-toolbar-background-add',
  },
  backgroundUpdate: {
    name: ORGANIZE_TAB_BACKGROUND_UPDATE,
    title: 'phantom_online:toolbar.organize.backgroundUpdate.title',
    tooltip: 'phantom_online:toolbar.organize.backgroundUpdate.tooltip',
    icon: 'fv__icon-toolbar-background-update',
  },
  backgroundRemoveAll: {
    name: ORGANIZE_TAB_BACKGROUND_REMOVEALL,
    title: 'phantom_online:toolbar.organize.backgroundRemoveAll.title',
    tooltip: 'phantom_online:toolbar.organize.backgroundRemoveAll.tooltip',
    icon: 'fv__icon-toolbar-background-remove',
  },
  headerfooter: {
    name: ORGANIZE_TAB_HEADER_FOOTER,
    title: 'phantom_online:toolbar.organize.headerfooter.title',
    icon: 'fv__icon-toolbar-headerfooter',
  },
  headerfooterAdd: {
    name: ORGANIZE_TAB_HEADER_FOOTER_ADD,
    title: 'phantom_online:toolbar.organize.headerfooterAdd.title',
    tooltip: 'phantom_online:toolbar.organize.headerfooterAdd.tooltip',
    icon: 'fv__icon-toolbar-watermark-add',
  },
  headerfooterUpdate: {
    name: ORGANIZE_TAB_HEADER_FOOTER_UPDATE,
    title: 'phantom_online:toolbar.organize.headerfooterUpdate.title',
    tooltip: 'phantom_online:toolbar.organize.headerfooterUpdate.tooltip',
    icon: 'fv__icon-toolbar-watermark-update',
  },
  headerfooterRemoveAll: {
    name: ORGANIZE_TAB_HEADER_FOOTER_REMOVEALL,
    title: 'phantom_online:toolbar.organize.headerfooterRemoveAll.title',
    tooltip: 'phantom_online:toolbar.organize.headerfooterRemoveAll.tooltip',
    icon: 'fv__icon-toolbar-watermark-remove',
  },
  batesNumbering: {
    name: ORGANIZE_TAB_BATES_NUMBERING,
    title: 'phantom_online:toolbar.organize.batesNumbering.title',
    icon: 'fv__icon-toolbar-batesnumbering',
  },
  batesNumberingAdd: {
    name: ORGANIZE_TAB_BATES_NUMBERING_ADD,
    title: 'phantom_online:toolbar.organize.headerfooterAdd.title',
    tooltip: 'phantom_online:toolbar.organize.headerfooterAdd.tooltip',
    icon: 'fv__icon-toolbar-watermark-add',
  },
  batesNumberingRemoveAll: {
    name: ORGANIZE_TAB_BATES_NUMBERING_REMOVEALL,
    title: 'phantom_online:toolbar.organize.headerfooterRemoveAll.title',
    tooltip: 'phantom_online:toolbar.organize.headerfooterRemoveAll.tooltip',
    icon: 'fv__icon-toolbar-watermark-remove',
  },
  pageDelete: {
    name: ORGANIZE_TAB_PAGE_DELETE,
    title: 'phantom_online:toolbar.organize.pageDelete.title',
    tooltip: 'phantom_online:toolbar.organize.pageDelete.tooltip',
    icon: 'fv__icon-toolbar-page-delete',
  },
  pageRotate: {
    name: ORGANIZE_TAB_PAGE_ROTATE,
    title: 'phantom_online:toolbar.organize.pageRotate.title',
    tooltip: 'phantom_online:toolbar.organize.pageRotate.tooltip',
    icon: 'fx-icon-ribbon_home_rotatepagesleft-32',
  },
  pageRotateLeft: {
    name: ORGANIZE_TAB_PAGE_ROTATE_LEFT,
    title: 'phantom_online:toolbar.organize.pageRotateLeft.title',
    tooltip: 'phantom_online:toolbar.organize.pageRotateLeft.tooltip',
    icon: 'fv__icon-toolbar-rotate-left',
  },
  pageRotateRight: {
    name: ORGANIZE_TAB_PAGE_ROTATE_RIGHT,
    title: 'phantom_online:toolbar.organize.pageRotateRight.title',
    tooltip: 'phantom_online:toolbar.organize.pageRotateRight.tooltip',
    icon: 'fv__icon-toolbar-rotate-right',
  },
  pageRotateMultiple: {
    name: ORGANIZE_TAB_PAGE_ROTATE_MULTIPLE,
    title: 'phantom_online:toolbar.organize.pageRotateMultiple.title',
    tooltip: 'phantom_online:toolbar.organize.pageRotateMultiple.tooltip',
    icon: 'fv__icon-toolbar-rotate-multiple',
  },
};
